import { type Column, type RowData } from "@tanstack/react-table-v9";

import { type TableAppFeatures } from "./tableHook";

type ColumnCssSizing = {
  width: number | string | undefined;
  minWidth: number | string | undefined;
  maxWidth: number | string | undefined;
};

export const getFixedCssSizing = (width: number | string): ColumnCssSizing => ({
  width,
  minWidth: width,
  maxWidth: width,
});

export const getColumnCssSizing = <TData extends RowData>(
  column: Column<TableAppFeatures, TData>,
): ColumnCssSizing => {
  const { meta, size, minSize, maxSize } = column.columnDef;

  if (meta?.width !== undefined) {
    return getFixedCssSizing(meta.width);
  }

  if (size !== undefined) {
    return getFixedCssSizing(size);
  }

  return { width: undefined, minWidth: minSize, maxWidth: maxSize };
};
